import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import Chart from 'chart.js';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { UserApiService } from 'src/app/users-management/user-api.service';
import {MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from 'src/app/services/auth.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  providers: [DatePipe]

})
export class DashboardComponent implements OnInit {
  @ViewChild('chart', { static: true }) chart: ElementRef;
  @ViewChild('guest', { static: true }) guest: ElementRef;
  displayColumns: string[] = ['userId', 'email', 'source','loginDate','role', 'actions']
  dataSource = new MatTableDataSource<any>([])
  dashboardData: any = { pageCounters: {} };
  // userGroupArray: any[] = [];
  loggedUser;
isLoading:boolean=false
  data: any;
  labels: string[] = []
  versions: number[] = []
  defVersions: number[] = []
  data1: any;
  guestVisites: number[] = []
  labelsVisites: string[] = []
  filter: any = "1"
  dataMonth: any;
  dataWeek: any;
  form = {
    pageSize: 7,
    pageNumber: 0,
    searchText: '',
    typeLogin:0
  }

  constructor(private authService:AuthService,private routing: Router, private userService: UserApiService, private httpClient: HttpClient, public datepipe: DatePipe, private snotifyService: ToastrService,) { }

  ngOnInit() {
    this.loggedUser = this.authService.getLoggedUser();
    this.GetDashboardData();
    this.GetAllGusets(1);
    this.getUserSession()
    // this.getOrder();
  }


  goToPage(page?) {
    if (page) {
      this.routing.navigate([page])
    }
  }

  getUserSession() {

    this.userService.getALLLoggedInUser(this.form).subscribe((res: any) => {
      this.dataSource = res.data
      this.isLoading=true;

    })
  }
  lockedOut(user) {
    let id = user.id
    this.userService.changedLookedOutStatus(id, !user.isLookedOut).subscribe((res) => {
      this.getUserSession()
    })
  }
  killUser(user){
    this.userService.killSession(user.id).subscribe((res)=>{
      this.snotifyService.success("", "Session has been killed successfully", {
        timeOut: 2000,
        progressBar: true,
        tapToDismiss: true,
      });
      this.getUserSession()
    })


  }
  GetDashboardData() {

    this.httpClient.get('/Dashboard/GetDashboardData').subscribe((res: any) => {
      if (res) {
        this.dashboardData = res;
        for (let i = 0; i < res.versionActivites.length; i++) {
          const element = res.versionActivites[i];
          if (element.versions == 0) {
            element.versions = 1
          }
          this.labels.push(element.user)
          this.versions.push(element.versions)
        }

        this.getBarData();
        this.getGuestData();
      }
    });
  };

  //only test
  GetAllGusets(Num: number) {
    this.labelsVisites = [];
    this.guestVisites = []
    this.httpClient.get('/Dashboard/GetAllGusets/' + Num).subscribe((res: any) => {
      if (res) {
        for (let j = 0; j < res.length; j++) {
          const element = res[j];
          if (element.visites > 0) {
            this.labelsVisites.push(this.datepipe.transform(element.date, 'dd/MM/yyyy'))
            this.guestVisites.push(element.visites)
          }
        }

        this.getGuestData()
      }
    });
  }


  getGuestData() {

    var data = {
      labels: this.labelsVisites,
      datasets: [
        {
          fill: true,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 12,
          borderColor: '#34bfa3',
          backgroundColor: '#34bfa3',
          label: 'Guest',
          data: this.guestVisites
        }
      ]
    };


    const chart = new Chart(this.guest.nativeElement, {
      type: 'line',
      data: data,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Dates',
              fontColor: "blue"
            },

          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Guests',
              fontColor: "blue"
            },

          }]
        },
        title: {
          display: true
        },
        hover: {
          mode: 'index'
        },

        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 5,
            bottom: 5
          }
        }
      }
    });
  }


  // ECOMMERCE
  orders: any[] = [];
  reviews: any[] = [];
  getOrder() {
    this.httpClient.get('/orders?status=' + null + '&numRecords=' + 5).subscribe((result: any) => {
      this.orders = result;
    });
  }

  getReviews() {
    this.httpClient.get('/reviews?status=' + null + '&numRecords=' + 5).subscribe((result: any) => {
      this.reviews = result;
    });
  }

  // ECOMMERCE

  
  checkRole(role:any){
    return this.loggedUser.RoleInfo.find(x=>x == role) || false;
  }

  getBarData() {
    this.data = {
      labels: this.labels,
      datasets: [
        {
          // label: 'dataset 1',
          // labels: this.labels,
          label: 'Versions of Page',
          backgroundColor: '#34bfa3',
          data: this.versions
        }
      ]
    };
    this.initBarChartJS();
  }




  initBarChartJS() {
    const chart = new Chart(this.chart.nativeElement, {
      type: 'bar',
      data: this.data,
      options: {
        title: {
          display: false,
        },
        tooltips: {
          intersect: false,
          mode: 'nearest',
          xPadding: 10,
          yPadding: 10,
          caretPadding: 10
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        // cornerRadius: 4,
        scales: {
          xAxes: [{
            display: false,
            gridLines: {
              display: false,
              drawTicks: false,
            },
            stacked: true
          }],
          yAxes: [{
            display: false,
            stacked: true,
            gridLines: {
              display: false,
              drawTicks: false,
            }
          }]
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        }
      }
    });
  }


  routeToStatistes(){
    this.routing.navigate(["/Ecommerce/products-dashbord-statistics"]);


}

routeToDashboard(){
 this.routing.navigate(["/Dashboard"]);
}




}
